import { Injectable } from '@angular/core';
import { GridDataService } from '../../../gk-kendo';
import { KlasouzytekResponseDto } from '../../../gk-map/models';

@Injectable({
  providedIn: 'any',
})
export class FspClassUseGridDataService extends GridDataService<KlasouzytekResponseDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
